export default __webpack_public_path__ + "static/media/linkedin-logo.25456ce4.png";